import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../constants/brandColors';

export const OpenQuestionStyles = makeStyles()((theme: Theme) => ({
  commentRoot: {
    padding: '0 2.4rem 0.875rem',
    [theme.breakpoints.up('md')]: {
      padding: '0rem 1rem 0.875rem 1rem',
    },
  },
  commentLbl: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginTop: '2.5rem',
    textAlign: 'left',
    color: theme.palette.default?.main || BrandColors.black,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
      marginTop: '3.125rem',
    },
  },
  commentBox: {
    width: '100%',
    overflow: 'auto !important',
    paddingBottom: '2rem',
    minHeight: '8.25rem !important',
    resize: 'none',
    border: '0.063rem solid',
    fontFamily: 'Open Sans',
    borderColor: theme.palette.primary.contrastText,
    boxShadow: `0rem 0.5rem 1.25rem ${BrandColors.blackWithOpacity08}`,
    boxSizing: 'border-box',
    padding: '0.625rem 0.75rem',
    fontSize: '0.875rem',
    background: theme.palette.background.paper,
    color: theme.palette.default?.main || BrandColors.black,
    [theme.breakpoints.up('sm')]: {
      height: '11.25rem !important',
      fontSize: '1rem',
      maxWidth: '45.25rem',
    },
  },
  charCount: {
    width: 'fit-content',
    float: 'right',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.default?.main || BrandColors.black,
    position: 'relative',
    top: '-1.97rem',
    right: '0.7rem',
    textAlign: 'right',
    [theme.breakpoints.up('sm')]: {
      right: '0.7rem',
    },
  },
  footerBack: {
    width: '50%',
    display: 'inline-block',
  },
  footerNext: {
    display: 'inline-block',
    width: '50%',
    flexDirection: 'row-reverse',
    textAlign: 'right',
    paddingRight: '2.375rem',
    [theme.breakpoints.up('md')]: {
      paddingRight: '1.875rem',
    },
  },
  disabled: {
    opacity: 0.4,
    border: `0.125rem solid ${theme.palette.default?.main || BrandColors.black} !important`,
    color: `${theme.palette.default?.main || BrandColors.black} !important`,
    pointerEvents: 'none',
  },
  error: {
    borderColor: BrandColors.red39,
  },
}));
